// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application";

import HelloController from "./hello_controller";
import AvatarUploadController from "./avatar_upload_controller";
import AlertController from "./alert_controller";
import CheckallController from "./checkall_controller";
import Decode64Controller from "./decode64_controller";
import DropdownController from "./dropdown_controller";
import ModalController from "./modal_controller";
import ModelviewController from "./modelview_controller";
import StickyController from "./sticky_controller";
import TogggleController from "./toggle_controller";
import SwiperController from "./swiper_controller";
application.register("hello", HelloController);
application.register("alert", AlertController);
application.register("avatar-upload", AvatarUploadController);
application.register("checkall", CheckallController);
application.register("decode64", Decode64Controller);
application.register("dropdown", DropdownController);
application.register("modal", ModalController);
application.register("modelview", ModelviewController);
application.register("sticky", StickyController);
application.register("swiper", SwiperController);
application.register("toggle", TogggleController);
